import Layout from '../views/Layout'

const route = {
  component: Layout,
  redirect: 'profile',
  path: '/profile',
  children: [{
    path: '/profile',
    name: 'profile',
    meta: { aliveName: 'profile', title: '公司简介管理' },
    component: resolve => require(['@/views/profile/index'], resolve)
  }
  ]
}
export default route



// WEBPACK FOOTER //
// ./src/router/profile.js